const __apiRootUrl = process.env.REACT_APP_API_URL?.slice(0, -8) ?? '';



export async function fetchFile(accessToken: string, fileKey: string) {
  const headers = new Headers();
  headers.append('Authorization', `Bearer ${accessToken}`);
  headers.append('Origin', window.location.origin);

  const response = await fetch(`${__apiRootUrl}/file/${fileKey}`, {
    method: 'GET',
    headers
  });

  if (response.status === 400) {
    throw new Error('Unauthorized');
  } else if (response.status === 403) {
    throw new Error('Download Limit Exceeded');
  }

  return await response.blob();
}
